import * as yup from "yup";
import { validate } from "@";

export const resendAllSchema = yup
  .object({
    fromDate: validate("req", "fromDate"),
    toDate: validate("req", "toDate"),
  })
  .required();

export const resendAllDefaultValues = {
  fromDate: "",
  toDate: "",
};
